module.exports = __webpack_public_path__ + "static/media/LogoAppMosph.fa9a694a.png";